import { Injectable } from '@angular/core';
import { combineQueries, QueryEntity, QueryConfig } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { UAVCommandQuery } from './uavcommand.query';
import { UAVsState, UAVsStore } from './uavs.store';
import { Observable, Observer } from 'rxjs';
import { UAVStatus } from '../../model/UAVStatus';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'dateCreated'
})
export class UAVsQuery extends QueryEntity<UAVsState> {

  constructor(protected store: UAVsStore, private uavCommandQuery: UAVCommandQuery) {
    super(store);
  }

  selectAllUAVsWithCommand() {
    const data = combineQueries([this.selectAll(),
    this.uavCommandQuery.selectAll({ asObject: true })]).pipe(
      map(([uavs, commands]) => uavs.map(uavStatus => ({
            ...uavStatus,
            uavCommand: commands[getCommandIdFromUAVStatus(uavStatus.id)]
          }))
      ));
    return data;
  }

  selectWithUAVCommand(uavId: string | number): Observable<UAVStatus> {
    return combineQueries([this.selectEntity(uavId), this.uavCommandQuery.selectEntity(getUAVIdFromUAVCommandId(uavId))]).pipe(
      map(([uavs, commands]) => ({
          ...uavs,
          uavCommand: commands
        })
      ));
  }

}
export const getCommandIdFromUAVStatus = (id: string | number) => {
  const pos = id.toString().lastIndexOf(':') + 1;
  const baseId = id.toString().substring(pos);
  return 'urn:ngsi-ld:UAVCommand:' + baseId;
};
export const getUAVIdFromUAVCommandId = (id: string | number) => {
  const pos = id.toString().lastIndexOf(':') + 1;
  const baseId = id.toString().substring(pos);
  return 'urn:ngsi-ld:UAVStatus:' + baseId;
};
